module.exports = __webpack_public_path__ + "img/title.a2c4eac0.png";